import React, { useState } from 'react';
import { PortalApplicationsService } from '../../../services/portal/portalApplicationsService';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

const OfferCard = ({ offer, onUpdate }) => {
    const [loading, setLoading] = useState(false);

    const handleAccept = async () => {
        if (!window.confirm('Are you sure you want to accept this offer?')) return;
        setLoading(true);
        const { error } = await PortalApplicationsService.acceptOffer(offer.id);
        setLoading(false);
        if (error) {
            alert('Failed to accept offer');
        } else {
            onUpdate();
        }
    };

    return (
        <div className="border border-slate-200 rounded-xl p-5 bg-white shadow-sm">
            <div className="flex justify-between items-start">
                <div>
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize mb-2
            ${offer.status === 'accepted' ? 'bg-emerald-100 text-emerald-800' :
                            offer.status === 'rejected' ? 'bg-rose-100 text-rose-800' : 'bg-blue-100 text-blue-800'}`}>
                        {offer.status}
                    </span>
                    <h4 className="text-lg font-semibold text-slate-900">{offer.offer_type || 'Offer'}</h4>
                    <p className="text-sm text-slate-500">Issued: {new Date(offer.issue_date).toLocaleDateString()}</p>
                </div>
                {offer.status === 'pending' && (
                    <div className="flex gap-2">
                        <button
                            onClick={handleAccept}
                            disabled={loading}
                            className="flex items-center gap-1 px-3 py-1.5 bg-emerald-600 text-white text-sm rounded-lg hover:bg-emerald-700 disabled:opacity-50"
                        >
                            <CheckCircleIcon className="h-4 w-4" />
                            Accept
                        </button>
                    </div>
                )}
            </div>

            <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
                <div>
                    <p className="text-slate-500">Tuition Fee</p>
                    <p className="font-medium text-slate-900">{offer.currency} {offer.tuition_fee}</p>
                </div>
                <div>
                    <p className="text-slate-500">Scholarship</p>
                    <p className="font-medium text-slate-900">{offer.scholarship_amount ? `${offer.currency} ${offer.scholarship_amount}` : '-'}</p>
                </div>
                <div>
                    <p className="text-slate-500">Deposit</p>
                    <p className="font-medium text-slate-900">{offer.deposit_amount ? `${offer.currency} ${offer.deposit_amount}` : '-'}</p>
                </div>
                <div>
                    <p className="text-slate-500">Expiry</p>
                    <p className="font-medium text-slate-900">{offer.expiry_date ? new Date(offer.expiry_date).toLocaleDateString() : '-'}</p>
                </div>
            </div>

            {offer.conditions && (
                <div className="mt-4 p-3 bg-slate-50 rounded-lg">
                    <p className="text-xs font-medium text-slate-500 uppercase mb-1">Conditions</p>
                    <p className="text-sm text-slate-700">{offer.conditions}</p>
                </div>
            )}
        </div>
    );
};

export default OfferCard;
